function SettlingInController(){
	this.className			= "SettlingInController";
	this.glob				= ["/settling-in**"];
}
SettlingInController.inheritsFrom( PageController );
SettlingInController.prototype.swap = function(onComplete){

	$.when(
		Preloader2.add("/assets/images/backgrounds/diamonds.svg?v=2"),
		Preloader2.add("/assets/images/patterns/diamond.svg?v=2")
	).then(() => {
		//Add a delay to all it to render
		setTimeout(() => onComplete(), 10);
	})

	return false;
}